import React from 'react';

import '../styles/PolicyPages.css';

function RefundPolicy() {
  return (
    <div className="policy-container">
      <h1>Refund & Cancellation Policy</h1>
      <p className="last-updated">Last Updated: December 5, 2025</p>

      <section>
        <h2>1. Order Cancellation</h2>
        <ul>
          <li>You can cancel your order within 24 hours of placing it for a full refund</li>
          <li>After 24 hours, cancellations may not be possible if the order has been processed or shipped</li>
        </ul>
        <h3>How to Cancel:</h3>
        <ul>
          <li>Go to your Account &gt; Orders</li>
          <li>Select the order you wish to cancel</li>
          <li>Click "Cancel Order" and confirm</li>
          <li>Refund will be processed within 5-7 business days</li>
        </ul>
      </section>

      <section>
        <h2>2. Return Policy</h2>
        <p>We accept returns within 7 days of delivery if:</p>
        <ul>
          <li>The product is defective or damaged</li>
          <li>Wrong item was delivered</li>
          <li>Product does not match the description</li>
        </ul>
        <p><strong>Non-returnable items:</strong></p>
        <ul>
          <li>Customized or personalized products</li>
          <li>Products marked as "Final Sale"</li>
          <li>Items damaged due to misuse</li>
        </ul>
      </section>

      <section>
        <h2>3. Return Process</h2>
        <ol>
          <li>Contact us at support@kalingastore.shop within 7 days of delivery</li>
          <li>Provide your order number and reason for return</li>
          <li>Pack the item securely in original packaging</li>
          <li>Ship the item back to the provided address</li>
          <li>Refund will be processed after inspection</li>
        </ol>
      </section>

      <section>
        <h2>4. Refund Timeline</h2>
        <ul>
          <li>Order Cancellation: 5-7 business days</li>
          <li>Product Return: 10-14 business days after receiving the item</li>
          <li>Refunds are issued to the original payment method</li>
          <li><strong>Note:</strong> Return shipping charges will be deducted from the refund amount.</li>
        </ul>
      </section>

      <section>
        <h2>5. Shipping Charges</h2>
        <ul>
          <li>Original shipping charges are non-refundable</li>
          <li>Exception: When return is due to our error (defective/damaged product or wrong item shipped)</li>
        </ul>
      </section>

      <section>
        <h2>6. Damaged or Defective Products</h2>
        <ul>
          <li>If you receive a damaged or defective product, please contact us immediately with photos</li>
          <li>We will arrange a replacement or full refund including shipping charges</li>
        </ul>
      </section>

      <section>
        <h2>7. Exchange Policy</h2>
        <ul>
          <li>We currently do not offer direct exchanges</li>
          <li>Please return the item for a refund and place a new order for the desired product</li>
        </ul>
      </section>

      <section>
        <h2>8. Contact Us</h2>
        <ul>
          <li><strong>Email:</strong> support@kalingastore.shop</li>
          <li><strong>Address:</strong> 12A, Old Vijay Nagar, Ghaziabad, Uttar Pradesh - 201001</li>
          <li><strong>Response time:</strong> Within 24-48 hours</li>
        </ul>
      </section>
    </div>
  );
}

export default RefundPolicy;
